import React from "react";
import { useState } from "@discovery/common-dplus/lib/hooks";
import { pipe } from "fp-ts/function";
import * as Option from "fp-ts/Option";
import * as styles from "./styles.css";
import { Typography, HeaderVariants, Tags } from "../../atoms/typography";
import * as M from "@discovery/prelude/lib/data/maybe";
import { getIsMobile } from "../../../utils/isMobile";
import { Link, LinkKind } from "../../../components/atoms/link";
import { Icon, Icons } from "../../../components/atoms/icon";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _user } from "@discovery/common-dplus/lib/state";
import { pushSocialShareEvent } from "@discovery/common-dplus/lib/adobe";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { _Config } from "@discovery/common-dplus/lib/state";
const playStore = require("../../../assets/google-play.svg");
export const Footer = ({ CopyRightInfo }) => {
    const [configM] = useGlobalState(_Config);
    const showExternalLinks = true; //client end flag to show external links or not
    const externalLinksM = M.chain((x) => x.externalLinks, configM);
    const externalLinksMarketingAdTnCM = M.chain((x) => x.marketingAdTnC, externalLinksM);
    const externalLinksDigitalAdFormM = M.chain((x) => x.onlineDigitalAdOrderForm, externalLinksM);
    const externalLinksZendeskSupportM = M.chain((x) => x.zendeskSupport, externalLinksM);
    const markertingAdTnC = pipe(externalLinksMarketingAdTnCM, Option.getOrElse(() => ""));
    const onlineDigitalAdForm = pipe(externalLinksDigitalAdFormM, Option.getOrElse(() => ""));
    const zendeskSupportUrl = pipe(externalLinksZendeskSupportM, Option.getOrElse(() => ""));
    const FooterLink = [
        {
            name: "Privacy Policy",
            url: "https://www.wbdprivacy.com/policycenter/b2c/",
            external: true,
        },
        {
            name: "Terms of Use",
            url: "/terms-of-use",
        },
        { name: "FAQ's", url: "/faq" },
    ];
    const adRelatedFooterLink = [
        {
            name: "Advertising Services Terms & Conditions",
            url: markertingAdTnC,
        },
        {
            name: "Online Advertising Order",
            url: onlineDigitalAdForm,
        },
        {
            name: "Support",
            url: zendeskSupportUrl,
        },
    ];
    const [userM] = useGlobalState(_user);
    const userDetails = {
        idM: M.map((user) => user.id, userM),
        anonymousM: M.map((user) => user.attributes.anonymous, userM),
        packagesM: M.chain((user) => user.attributes.packages, userM),
    };
    const userPackage = M.fromMaybe(userDetails.packagesM, [""]);
    const userType = userPackage[0];
    const isAnonymous = M.fromMaybe(userDetails.anonymousM, false);
    const userId = M.fromMaybe(userDetails.idM, "");
    const [onHover, setHoverAction] = useState(false);
    const [indexValue, setIndex] = useState(0);
    const handleMouseEnter = (index) => {
        const isMouseHovered = getIsMobile() ? false : true;
        setHoverAction(isMouseHovered);
        setIndex(index);
    };
    const handleMouseLeave = () => {
        setHoverAction(false);
    };
    const RenderFollowUsLinks = () => {
        const selected = onHover && indexValue === 0;
        const selectedFb = onHover && indexValue === 1;
        return (React.createElement("div", { className: styles.followWrapper },
            React.createElement("div", { onMouseEnter: () => handleMouseEnter(0), onMouseLeave: handleMouseLeave, id: "followUs", onClick: () => pushSocialShareEvent("social follow", "youtube", config.footer.youTubeUrlForFollowUs, "youtube", isAnonymous, userType, userId) },
                React.createElement(Link, { href: config.footer.youTubeUrlForFollowUs, kind: LinkKind.external, openInNewWindow: true },
                    React.createElement(Icon, { type: Icons.YoutubeIcon, className: styles.snIcon, color: selected ? "#FE0101" : "#313740", subColor: selected ? "#FFF" : "#BDC1C8" }))),
            React.createElement("div", { onClick: () => pushSocialShareEvent("social follow", "facebook", config.footer.fbUrlForFollowUs, "facebook", isAnonymous, userType, userId), onMouseEnter: () => handleMouseEnter(1), onMouseLeave: handleMouseLeave, id: "followUs" },
                React.createElement(Link, { href: config.footer.fbUrlForFollowUs, kind: LinkKind.external, openInNewWindow: true },
                    React.createElement(Icon, { type: Icons.FB, className: styles.snIcon, color: selectedFb ? "#1877F2" : "#fff", subColor: selectedFb ? "#FFF" : "#313740" })))));
    };
    const RenderAppStoreBadges = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "storeIcon", onClick: () => pushSocialShareEvent("social follow", "app store", config.footer.appStoreLink, "appStore", isAnonymous, userType, userId) },
                React.createElement(Link, { href: config.footer.appStoreLink, kind: LinkKind.external, openInNewWindow: true },
                    React.createElement(Icon, { type: Icons.AppStore, className: styles.snIcon }))),
            React.createElement("div", { id: "storeIcon", onClick: () => pushSocialShareEvent("social follow", "google play", config.footer.playStoreLink, "playStore", isAnonymous, userType, userId) },
                React.createElement(Link, { href: config.footer.playStoreLink, kind: LinkKind.external, openInNewWindow: true },
                    React.createElement("img", { src: playStore, className: styles.snIcon })))));
    };
    const RenderFooterLinks = () => {
        return (React.createElement("div", { className: styles.footerContainerForMobile },
            React.createElement("div", { className: styles.footerWrapperMobile },
                React.createElement(Link, { href: `mailTo:${config.footer.mailToDiscoveryPlus}`, kind: LinkKind.external, openInNewWindow: true },
                    React.createElement("div", { className: styles.mailItems },
                        React.createElement("div", { className: styles.image },
                            React.createElement(Icon, { type: Icons.Mail, className: styles.contactUsimage, color: "white" })),
                        React.createElement("div", { id: "email" },
                            React.createElement(Typography, { classNameM: M.of(styles.footerMailTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                                React.createElement(React.Fragment, null, config.footer.mailToDiscoveryPlus))))),
                React.createElement("div", { className: styles.mailItems },
                    React.createElement("div", { className: styles.phone },
                        React.createElement(Icon, { type: Icons.Phone, className: styles.contactUsimage, color: "white" })),
                    React.createElement("div", { style: { display: "inline" } },
                        React.createElement(Typography, { classNameM: M.of(styles.footerMailTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                            React.createElement("a", { href: "tel:02243491100" }, config.footer.discoveryPhoneNo)))),
                React.createElement("div", { className: styles.mailItems },
                    React.createElement("div", { className: styles.address },
                        React.createElement(Icon, { type: Icons.DPlusIcon, className: styles.contactUsimage, color: "white" })),
                    React.createElement(Typography, { classNameM: M.of(styles.footerMailTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, config.footer.discoveryAddress2))))));
    };
    const RenderLinks = () => {
        return (React.createElement("div", { className: styles.links }, FooterLink.map(({ url, name }, index) => (React.createElement("div", { className: styles.footerLinks, key: index },
            React.createElement(Link, { href: url +
                    `?displayFooter=false&displayMenu=false&displayHeader=false`, kind: LinkKind.external, openInNewWindow: true },
                React.createElement("div", { id: "footerLinks" }, name)))))));
    };
    return (React.createElement("div", { className: styles.footerWrapper },
        React.createElement("div", { className: styles.footerContainer },
            React.createElement("div", { className: styles.linksContainer },
                React.createElement(RenderFooterLinks, null),
                React.createElement("div", { className: styles.footerSeparator })),
            React.createElement("div", { className: styles.socialNetwork },
                React.createElement("div", { className: styles.snHeading }, "Follow us"),
                React.createElement("span", { className: styles.appServiceIcons },
                    React.createElement(RenderAppStoreBadges, null)),
                React.createElement(RenderFollowUsLinks, null),
                React.createElement("div", { className: styles.snHeading }, "discovery+ App"),
                React.createElement("div", { className: styles.appService },
                    React.createElement(RenderAppStoreBadges, null))),
            React.createElement("div", { className: styles.adRelatedLinksWrapper }, adRelatedFooterLink.map(({ url, name }, index) => (React.createElement("div", { className: styles.adRelatedfooterLinks, key: index },
                React.createElement(Link, { href: url, kind: LinkKind.external, openInNewWindow: true }, name))))),
            React.createElement("div", { className: styles.linksWrapper },
                React.createElement(RenderLinks, null),
                " "),
            React.createElement("div", { className: styles.footerSeparatorLinks }),
            React.createElement("div", { className: styles.copyrightsContainer },
                React.createElement("div", { className: styles.links }, FooterLink.map(({ url, name }, index) => (React.createElement("div", { className: styles.footerLinks, key: index },
                    React.createElement(Link, { href: url, kind: LinkKind.external, openInNewWindow: true }, name))))),
                React.createElement("div", { className: styles.coprightText }, CopyRightInfo))),
        React.createElement("div", { className: styles.footerContainerForWeb },
            React.createElement("div", { className: styles.footerWrapperWeb },
                React.createElement(Link, { href: `mailTo:${config.footer.mailToDiscoveryPlus}`, kind: LinkKind.external, openInNewWindow: true },
                    React.createElement("div", { className: styles.mailItems },
                        React.createElement("div", { className: styles.image },
                            React.createElement(Icon, { type: Icons.Mail, className: styles.contactUsimage, color: "white" })),
                        React.createElement("div", { id: "desktopEmail" },
                            React.createElement(Typography, { classNameM: M.of(styles.footerMailLink), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                                React.createElement(React.Fragment, null, config.footer.mailToDiscoveryPlus))))),
                React.createElement("div", { className: styles.mailItems },
                    React.createElement("div", { className: styles.phone },
                        React.createElement(Icon, { type: Icons.Phone, className: styles.contactUsimage, color: "white" })),
                    React.createElement(Typography, { classNameM: M.of(styles.footerMailTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement("a", { href: "tel:02243491100" }, config.footer.discoveryPhoneNo))),
                React.createElement("div", { className: styles.mailItems },
                    React.createElement("div", { className: styles.address },
                        React.createElement(Icon, { type: Icons.DPlusIcon, className: styles.contactUsimage, color: "white" })),
                    React.createElement(Typography, { classNameM: M.of(styles.footerMailTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, config.footer.discoveryAddress2)))),
            React.createElement("div", { className: styles.followUsWrapper },
                React.createElement("div", { className: styles.followUsWeb },
                    React.createElement(Typography, { classNameM: M.of(styles.footerMailTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, "Follow us")),
                    React.createElement(RenderFollowUsLinks, null)),
                React.createElement("div", { className: styles.appStoreLinks },
                    React.createElement(Typography, { classNameM: M.of(styles.footerMailTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, "discovery+ App")),
                    React.createElement("div", { className: styles.appStoreBadges },
                        React.createElement(RenderAppStoreBadges, null))))),
        React.createElement("div", { className: styles.footerLinksForWeb },
            React.createElement("div", { className: styles.linksWeb },
                showExternalLinks && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.footerLinksTextForWeb }, adRelatedFooterLink.map(({ url, name }) => (React.createElement("div", { className: styles.adRelatedfooterLinks, key: name },
                        React.createElement(Link, { href: url, kind: LinkKind.external, openInNewWindow: true },
                            React.createElement("div", { id: "footerLinks" }, name)))))),
                    React.createElement("div", { className: styles.footerSeparatorLinks }))),
                React.createElement("div", { className: styles.footerLinksTextForWeb },
                    FooterLink.map(({ url, name, external }) => (React.createElement("div", { className: styles.footerLinks, key: name },
                        React.createElement(Link, { href: url +
                                `${!external
                                    ? "?displayFooter=false&displayMenu=false&displayHeader=false"
                                    : ""}`, kind: LinkKind.external, openInNewWindow: true },
                            React.createElement("div", { id: "footerLinks" }, name))))),
                    React.createElement("div", { className: styles.coprightText, id: "copyRight" }, CopyRightInfo))))));
};

